import { render, staticRenderFns } from "./SettlementModal.vue?vue&type=template&id=4ad9a3de&"
import script from "./SettlementModal.vue?vue&type=script&lang=js&"
export * from "./SettlementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports